export default __webpack_public_path__ + "static/media/jillions.5dc9ab71.png";